import React, { useRef, useState } from 'react';
import './Page4.css';

import playButtonImage from './../assets/commum/button_play.png';
import videoEN from './../assets/page4/INCPro_EN.mp4';
import videoPT from './../assets/page4/INCPro_PT.mp4';
import videoES from './../assets/page4/INCPro_ES.mp4';
import bgImage from './../assets/commum/bg_geral.png';
import languageButtonImagePT from './../assets/commum/button_PT.png';
import languageButtonImageES from './../assets/commum/button_ES.png';
import languageButtonImageEN from './../assets/commum/button_EN.png';

function Page4() {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [videoSource, setVideoSource] = useState(videoEN);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  const handleVideoEnd = () => {
    setIsPlaying(false);
  };

  const changeVideo = (source) => {
    if (videoRef.current) {
      videoRef.current.pause();
      setIsPlaying(false);
      setVideoSource(source);
    }
  };

  return (
    <div className="page4-container" style={{ backgroundImage: `url(${bgImage})` }}>
      <video
        ref={videoRef}
        className="video-player"
        src={videoSource}        
        onEnded={handleVideoEnd}
        width="960"
        height="540"
        style={{ width: '960px', height: '540px' }}
      />
      {!isPlaying && (
        <img
          src={playButtonImage}
          alt="Play Button"
          className="play-button"
          onClick={handlePlay}
        />
      )}
      <div className="switch-button" style={{ top: '791px', left: '218px', width: '76px', height: '50px' }} onClick={() => changeVideo(videoPT)}>
        <img src={languageButtonImagePT} alt="Portuguese Button" />
      </div>
      <div className="switch-button" style={{ top: '791px', left: '307px', width: '76px', height: '50px' }} onClick={() => changeVideo(videoES)}>
        <img src={languageButtonImageES} alt="Spanish Button" />
      </div>
      <div className="switch-button" style={{ top: '791px', left: '394px', width: '76px', height: '50px' }} onClick={() => changeVideo(videoEN)}>
        <img src={languageButtonImageEN} alt="English Button" />
      </div>      
    </div>
  );
}

export default Page4;
